import { Badge } from 'components/atoms';
import React from 'react';

const NewBadge = ({ children }) => <Badge className="badge--new badge"> {children} </Badge>;

export default NewBadge;
